import * as Types from '../../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateNewOrderMutationVariables = Types.Exact<{
  orderAttributes: Types.DraftOrderDto;
}>;


export type CreateNewOrderMutation = { __typename?: 'mutation_root', result: { __typename?: 'CreateDraftOrderResponse', success: boolean, orderId: number, session: { __typename?: 'AuthSuccess', type: string, token: string } } };


export const CreateNewOrderDocument = gql`
    mutation createNewOrder($orderAttributes: DraftOrderDto!) {
  result: nest_createDraftOrder(orderAttributes: $orderAttributes) {
    success
    orderId
    session {
      type
      token
    }
  }
}
    `;
export function useCreateNewOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewOrderMutation, CreateNewOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewOrderMutation, CreateNewOrderMutationVariables>(CreateNewOrderDocument, options);
      }
export type CreateNewOrderMutationHookResult = ReturnType<typeof useCreateNewOrderMutation>;
export type CreateNewOrderMutationResult = Apollo.MutationResult<CreateNewOrderMutation>;
export type CreateNewOrderMutationOptions = Apollo.BaseMutationOptions<CreateNewOrderMutation, CreateNewOrderMutationVariables>;